<script>
import Layout from '@layouts/main'
import { widgetActions } from '@state/helpers'
import { mapGetters, mapState } from 'vuex'

import axios from 'axios'
import zendesk from '@mixins/zendesk-utils.js'
import commomUtils from '@mixins/common-utils.js'
import samUtils from '@mixins/sam-utils.js'
import deepLink from '@mixins/deeplink.js'
import ENV from '@src/env'
import Raven from 'raven-js'

import { getComponents } from './utils'

export default {
  page: {
    title: 'Widgets',
    meta: [{ name: 'description', content: 'Widgets' }],
  },
  components: {
    Layout,
  },
  mixins: [zendesk(), commomUtils(), samUtils(), deepLink()],
  data () {
    return {
      loading: false,
      error: null,
      componentList: [],
      params: {},
      userCountry: '',
    }
  },
  computed: {
    ...mapState('widgets', {
      user: state => state.data.SharedData.userData,
    }),
    ...mapState('zendesk', {
      fetching: state => state.fetching,
    }),
    ...mapGetters('widgets', ['userEnv', 'zendeskArticleParams']),
  },
  watch: {
    $route: 'fetchArticleScreen',
  },
  created () {
    try {
      // report entrance for g-analytics
      this.$ga.page(this.$router)
      this.initStore()
      const { screenId } = this.$route.params
      this.params = Object.assign({}, this.$route.query, {
        screen_id: screenId,
      })
      this.validateParams(this.params)
      this.fetchArticleScreen()
    } catch (err) {
      this.error = err.toString()
    }
  },
  methods: {
    ...widgetActions,
    initStore () {
      const { country_code: countryCode, token } = this.$route.query
      this.commitUser({
        countryCode,
        token,
        os: this.getMobileOperatingSystem(),
      })
      this.commitParams(this.$route.params)
      this.commitQuery(this.$route.query)
    },
    fetchArticleScreen () {
      this.error = null
      this.loading = true
      return axios
        .post(
          `${
          ENV.rappi.url[this.userEnv]
          }/api/support-flows/screens/build-screen`,
          this.zendeskArticleParams,
          {
            headers: { Authorization: 'Bearer ' + this.params.token },
          }
        )
        .then(
          ({ data }) => {
            this.loading = false
            const { screenWidgets } = data.data
            this.componentList = getComponents(screenWidgets)
            this.componentList.map(c => this.commitWidgetData(c))
          },
          err => {
            Raven.captureException(err)
            this.loading = false
            this.error = err.toString()
          }
        )
    },
    getComponent ({ component }) {
      return component()
    },
    onChildChange (childData) { },
  },
}
</script>

<template>
  <Layout>
    <div :class="$style.container">
      <div :class="[{ [$style.container__spacerBig]: loading || error }, $style.container__spacerSmall]" />
      <div
        v-if="loading || fetching"
        :class="$style.container__loading"
      >
        <v-progress-circular
          :width="3"
          indeterminate
        />
      </div>

      <div
        v-if="error"
        :class="$style.container__error"
      >
        {{ error }}
      </div>
      <div v-if="!fetching">
        <div
          v-for="component in componentList"
          :key="component.key"
        >
          <component
            :is="getComponent(component)"
            :class="$style.component"
            :token="params.token"
            :component-data="JSON.parse(JSON.stringify(component.data))"
            :user-country="userEnv"
          />
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped lang="scss" module>
@import '@design';
.container {
  &__loading {
    height: 100vh;
    padding-top: 10rem;
    color: $primary-green;
  }

  &__error {
    height: 100vh;
    padding-top: 10rem;
  }

  &__spacer {
    &Small {
      height: 1px;
    }

    &Medium {
      height: 6rem;
    }

    &Big {
      height: 1px;
    }
  }
}
.component {
  width: auto;
  padding: 0.5rem 0 0.5rem 0;

  // &:not(:last-child) {
  margin-bottom: 1rem;
  // }

  &:first-child {
    margin-top: 1rem;
  }

  &:only-child {
    // margin-top: 0;
  }
}

.btnContainer {
  width: 100%;
  margin-bottom: 2rem;

  > button {
    &:focus {
      outline: 0;
    }
  }
}
</style>
